(function () {
  const Core = window.RB.Core;
  const { equip, buff } = window.RB.CardLib;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Brutalizer": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["calm"] }),
      ],
      attachedMightSpecs: [{ n: 2, cond: { k: "gearAttachedThisTurn" } }],
    },

    "Desert's Call": {
      play: [
        { op: "token", name: "Sand Soldier", n: 1, loc: "base", exhausted: false },
      ],
      repeatCosts: [{ cost: { energy: 2, pips: 0, anyPower: 0, domains: null } }],
    },

    "Disarming Rake": {
      play: [
        {
          op: "may",
          prompt: "You may kill a gear?",
          then: [
            { op: "choose", bind: "t1", spec: { type: "gear" }, prompt: "Kill..." },
            { op: "kill", to: "$t1" },
          ],
        },
      ],
    },

    "Doran's Shield": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["calm"] }),
      ],
      attachedKw: [["tank", null]],
    },

    "Feral Strength": {
      play: [buff("$t1", 2)],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Give +2 Might to..." }],
      repeatCosts: [{ cost: { energy: 2, pips: 0, anyPower: 0, domains: null } }],
    },

    "Fire Below the Mountain": { legendAdd: { energy: 0, anyPower: 1, domain: null, only: "gear" } },

    "Forgefire Cape": {
      abilities: [
        equip({ energy: 0, pips: 0, anyPower: 1, domains: null }),
      ],
      attachedTriggers: [
        {
          on: "attack",
          optional: false,
          label: "When I attack or defend, deal 2 to all enemy units here",
          targets: [],
          program: [{ op: "deal", n: 2, spec: { type: "unit", here: true, enemy: true } }],
          self: true,
        },
        {
          on: "defend",
          optional: false,
          label: "When I attack or defend, deal 2 to all enemy units here",
          targets: [],
          program: [{ op: "deal", n: 2, spec: { type: "unit", here: true, enemy: true } }],
          self: true,
        },
      ],
    },

    "Guardian Angel": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["calm"] }),
      ],
      attachedDeathReplace: { killGear: true, heal: true, exhaust: true, recall: true },
    },

    "Heart of Dark Ice": {
      abilities: [
        {
          cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
          exhausts: true,
          label: "Heart of Dark Ice",
          targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Give +3 Might to..." }],
          program: [buff("$t1", 3)],
        },
      ],
    },

    "Legion Quartermaster": {
      addCosts: [
        {
          optional: false,
          cond: null,
          label: "Legion Quartermaster",
          costReturn: { type: "gear" },
        },
      ],
    },

    "Navori Scout": {},

    "Poro Snax": {
      play: [{ op: "draw", n: 1 }],
      abilities: [
        {
          cost: { energy: 1, pips: 1, anyPower: 0, domains: ["calm"] },
          exhausts: true,
          killSelf: true,
          label: "Poro Snax",
          targets: [],
          program: [{ op: "draw", n: 1 }],
        },
      ],
    },

    "Rabadon's Deathcrown": {
      abilities: [
        equip({ energy: 0, pips: 0, anyPower: 1, domains: null }),
      ],
      attachedBonusDamage: 3,
    },

    "Ribbon Dancer": {
      triggers: [
        {
          on: "move",
          optional: false,
          label: "When I move to a battlefield, give another friendly unit +1 :rb_might: this turn",
          targets: [
            {
              bind: "t1",
              spec: { type: "unit", friendly: true, other: true },
              prompt: "Give +1 Might to...",
            },
          ],
          program: [buff("$t1", 1)],
          self: true,
          condSpec: { k: "evToBf" },
        },
      ],
    },

    "Shurelya's Requiem": {
      play: [{ op: "ready", spec: { type: "unit", friendly: true } }],
      abilities: [
        equip({ energy: 0, pips: 0, anyPower: 1, domains: null }),
      ],
      attachedAuraKw: [{ name: "ganking", value: null, scope: "here" }],
    },

    "Stellacorn Herder": {
      triggers: [
        {
          on: "move",
          optional: false,
          label: "When I move, draw 1",
          targets: [],
          program: [{ op: "draw", n: 1 }],
          self: true,
        },
      ],
    },

    "Sterak's Gage": {
      play: [{ op: "attachSource", to: "$_qd" }],
      targets: [
        {
          bind: "_qd",
          spec: { type: "unit", friendly: true },
          prompt: "Attach Sterak's Gage to which unit?",
        },
      ],
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["calm"] }),
      ],
    },

    "Svellsongur": {
      abilities: [
        equip({ energy: 1, pips: 1, anyPower: 0, domains: ["calm"] }),
      ],
      attachedCopyHost: true,
    },

    "Aphelios, Exalted": {
      triggers: [{
        on: "attached",
        condSpec: { k: "and", conds: [{ k: "evHostSelf" }, { k: "evIsEquipment" }] },
        label: "Equipment attached: choose a mode not chosen this turn",
        program: [{
          op: "modalOnce",
          prompt: "Aphelios, Exalted - choose one that hasn't been chosen this turn",
          modes: [
            { label: "Ready 2 runes", then: [{ op: "readyRunes", n: 2 }] },
            { label: "Channel 1 rune exhausted", then: [{ op: "channel", n: 1, exhausted: true }] },
            {
              label: "Buff a friendly unit",
              then: [
                { op: "choose", bind: "apb", spec: { type: "unit", friendly: true }, prompt: "Buff which friendly unit?" },
                { op: "buff", to: "$apb" },
              ],
            },
          ],
        }],
      }],
    },

    "Azir, Ascendant": {
      abilities: [{
        label: "Swap places with a friendly unit",
        cost: { energy: 0, pips: 1, anyPower: 0, domains: ["calm"] },
        action: true, oncePerTurn: true,
        targets: [{
          bind: "az", spec: { type: "unit", friendly: true, other: true },
          prompt: "Swap places with which unit you control?",
        }],
        program: [
          { op: "swapLoc", a: "source", b: "$az" },
          { op: "attachFrom", from: "$az", to: "source", prompt: "Attach one of its Equipment to me?" },
        ],
      }],
    },

    "Guardian of the Passage": {
      triggers: [{
        on: "unitHold",
        self: true,
        optional: true,
        label: "hold: return a unit or gear from your trash",
        program: [
          {
            op: "choose", bind: "t",
            spec: { orSpecs: [{ zone: "trash", type: "unit" }, { zone: "trash", type: "gear" }] },
            prompt: "Return which unit or gear from your trash to your hand?",
          },
          { op: "toHand", to: "$t" },
        ],
      }],
    },

    "Lonely Poro": {
      deathknell: [{
        op: "if", cond: { k: "ctxBf" },
        then: [{
          op: "if",
          cond: { k: "count", spec: { type: "unit", friendly: true, here: true }, n: 0, cmp: "exactly" },
          then: [{ op: "draw", n: 1 }],
        }],
        else: [{
          op: "if",
          cond: { k: "count", spec: { type: "unit", friendly: true, inBase: true }, n: 0, cmp: "exactly" },
          then: [{ op: "draw", n: 1 }],
        }],
      }],
    },

    "Apprentice Smith": {
      triggers: [{
        on: "move",
        self: true,
        label: "move: reveal the top card, draw it if it is a gear",
        program: [{
          op: "lookTopTake", n: 1, public: true, take: "hand", filter: { type: "gear" },
          prompt: "Draw the revealed gear",
        }],
      }],
    },

    "Emperor's Divide": {
      targets: [{
        bind: "a",
        spec: { type: "unit", friendly: true, atBf: true },
        min: 0, max: 8, cohereLoc: true,
        prompt: "Move any number of your units at one battlefield to their base",
      }],
      play: [{ op: "move", to: "$a", dest: "base" }],
    },

    "Janna, Savior": {
      play: [
        { op: "heal", spec: { type: "unit", friendly: true, here: true } },
        {
          op: "choose", bind: "e",
          spec: { type: "unit", enemy: true, here: true },
          prompt: "Move which enemy unit here to its base?",
        },
        { op: "move", to: "$e", dest: "base" },
      ],
    },

    "Simian Ancestor": {
      triggers: [{
        on: "buffed",
        self: true,
        you: true,
        label: "buffed: ready me",
        program: [{ op: "ready", to: "source" }],
      }],
    },

    "Ornn, Blacksmith": {
      play: [{
        op: "lookTopTake", n: 4, optional: true, take: "hand", filter: { type: "gear" },
        prompt: "Reveal a gear from among them and draw it (or take none)",
      }],
      triggers: [{
        on: "unitHold",
        self: true,
        label: "hold: look at the top 4 for a gear",
        program: [{
          op: "lookTopTake", n: 4, optional: true, take: "hand", filter: { type: "gear" },
          prompt: "Reveal a gear from among them and draw it (or take none)",
        }],
      }],
    },

    "Tianna Crownguard": {
      restrictScore: [{ who: "enemy", whileAtBf: true, reason: "Tianna Crownguard is at a battlefield" }],
    },

    "Grandmaster at Arms": {
      abilities: [{
        cost: { energy: 1, pips: 0, anyPower: 0, domains: null },
        exhausts: true,
        label: "Attach a detached Equipment you control to a unit you control",
        targets: [
          {
            bind: "g", spec: { type: "gear", tag: "Equipment", friendly: true },
            prompt: "Attach which detached Equipment?",
          },
          { bind: "u", spec: { type: "unit", friendly: true }, prompt: "Attach it to which friendly unit?" },
        ],
        program: [{ op: "attach", to: "$g", host: "$u" }],
      },
      {
        cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
        exhausts: true,
        label: "Attach an attached Equipment you control to a unit you control",
        targets: [
          {
            bind: "g", spec: { type: "gear", equipment: true, friendly: true, attached: true, isAttached: true },
            prompt: "Move which attached Equipment?",
          },
          { bind: "u", spec: { type: "unit", friendly: true }, prompt: "Attach it to which friendly unit?" },
        ],
        program: [{ op: "attach", to: "$g", host: "$u" }],
      }],
    },

    "Blade Dancer": {
      triggers: [{
        on: "conquer", you: true, optional: true,
        label: "pay 1 Energy to ready me",
        condSpec: { k: "not", cond: { k: "selfReady" } },
        program: [
          { op: "payCost", cost: { energy: 1, pips: 0, anyPower: 0, domains: null }, skipOnFail: 1 },
          { op: "ready", to: "source" },
        ],
      },
      {
        on: "targeted", optional: true, exhaustSelf: true,
        label: "you chose a friendly unit: exhaust me and pay to ready it",
        condSpec: {
          k: "and",
          conds: [{ k: "evTargetsFriendlyUnit", byYou: true }, { k: "selfReady" }],
        },
        targets: [{
          bind: "t", spec: { type: "unit", friendly: true, isEvTarget: true },
          prompt: "Ready which unit you chose?",
        }],
        program: [
          { op: "exhaust", to: "source" },
          { op: "payCost", cost: { energy: 0, pips: 0, anyPower: 1, domains: null }, skipOnFail: 1 },
          { op: "ready", to: "$t" },
        ],
      }],
    },

    "Defiant Dance": {
      targets: [
        { bind: "a", spec: { type: "unit" }, prompt: "Give which unit +2 Might this turn?" },
        { bind: "b", spec: { type: "unit", notBind: "a" }, prompt: "Give which other unit -2 Might this turn?" },
      ],
      play: [
        buff("$a", 2),
        buff("$b", -2),
      ],
    },

    "Emperor of the Sands": {
      abilities: [{
        cost: { energy: 1, pips: 0, anyPower: 0, domains: null },
        exhausts: true,
        requiresEquipmentPlayed: true,
        label: "Play a 2 Might Sand Soldier unit token to your base",
        targets: [],
        program: [{ op: "token", name: "Sand Soldier" }],
      }],
      auraKwSpecs: [{
        name: "weaponmaster", value: null,
        targetCond: { k: "selfName", name: "Sand Soldier" },
      }],
    },

    "Arise!": {
      play: [
        {
          op: "if",
          cond: { k: "count", spec: { type: "gear", tag: "Equipment", friendly: true, attached: true, ignoreUntargetable: true }, n: 1 },
          then: [{ op: "token", name: "Sand Soldier", ready: true }],
        },
        {
          op: "if",
          cond: { k: "count", spec: { type: "gear", tag: "Equipment", friendly: true, attached: true, ignoreUntargetable: true }, n: 2 },
          then: [{ op: "token", name: "Sand Soldier", ready: true }],
        },
        {
          op: "if",
          cond: { k: "count", spec: { type: "gear", tag: "Equipment", friendly: true, attached: true, ignoreUntargetable: true }, n: 3 },
          then: [{ op: "token", name: "Sand Soldier" }],
        },
        {
          op: "if",
          cond: { k: "count", spec: { type: "gear", tag: "Equipment", friendly: true, attached: true, ignoreUntargetable: true }, n: 4 },
          then: [{ op: "token", name: "Sand Soldier" }],
        },
        {
          op: "if",
          cond: { k: "count", spec: { type: "gear", tag: "Equipment", friendly: true, attached: true, ignoreUntargetable: true }, n: 5 },
          then: [{ op: "token", name: "Sand Soldier" }],
        },
        {
          op: "if",
          cond: { k: "count", spec: { type: "gear", tag: "Equipment", friendly: true, attached: true, ignoreUntargetable: true }, n: 6 },
          then: [{ op: "token", name: "Sand Soldier" }],
        },
        {
          op: "if",
          cond: { k: "count", spec: { type: "gear", tag: "Equipment", friendly: true, attached: true, ignoreUntargetable: true }, n: 7 },
          then: [{ op: "token", name: "Sand Soldier" }],
        },
        {
          op: "if",
          cond: { k: "count", spec: { type: "gear", tag: "Equipment", friendly: true, attached: true, ignoreUntargetable: true }, n: 8 },
          then: [{ op: "token", name: "Sand Soldier" }],
        },
      ],
    },

    "Royal Entourage": {
      play: [
        { op: "choose", bind: "l", spec: { zone: "legend", anyPlayer: true }, prompt: "Ready or exhaust which legend?" },
        {
          op: "option", varKey: "re",
          prompt: "Ready it or exhaust it?",
          options: ["Ready", "Exhaust"],
        },
        {
          op: "if", cond: { k: "varEq", key: "re", value: 0 },
          then: [{ op: "ready", to: "$l" }],
          else: [{ op: "exhaust", to: "$l" }],
        },
      ],
    },

    "Thwonk!": {
      repeatCosts: [{ cost: { energy: 2, pips: 0, anyPower: 0, domains: null } }],
      targets: [{
        bind: "t", spec: { type: "unit", attacking: true },
        prompt: "Stun which attacking unit?",
      }],
      play: [{ op: "stun", to: "$t" }],
    },

    "Not So Fast": {
      targets: [{
        bind: "t",
        spec: {
          zone: "chain", enemy: true, counterable: true, kinds: ["spell", "ability"],
          targetsMatching: {
            orSpecs: [
              { type: "unit", friendly: true },
              { type: "gear", friendly: true },
            ],
          },
        },
        prompt: "Counter which enemy spell or ability?",
      }],
      play: [{ op: "counter", to: "$t" }],
    },

    "Jax, Unmatched": {
      auraPlayKwSpecs: [{
        name: "quick-draw", value: null, inHand: true,
        what: { type: "gear" }, cond: null,
      }],
    },

    "Needlessly Large Yordle": {
      costMods: [{
        energyLess: { turnFactOf: "heldPoints", times: 2 },
        powerLess: { turnFactOf: "heldPoints" },
      }],
    },

    "Irelia, Fervent": {
      triggers: [
        {
          on: "targeted",
          label: "chosen: +1 Might this turn",
          condSpec: { k: "evTargetsSelf" },
          program: [buff("source", 1)],
        },
        {
          on: "ready", self: true,
          label: "readied: +1 Might this turn",
          program: [buff("source", 1)],
        },
      ],
    },

    "Counter Strike": {
      targets: [{ bind: "t", spec: { type: "unit" }, prompt: "Prevent the next damage dealt to which unit?" }],
      play: [
        { op: "prevent", to: "$t", amount: "all", dur: "turn" },
        { op: "draw", n: 1 },
      ],
    },
  });
})();
